module.exports = __webpack_public_path__ + "assets/img/00146.0062a9af.png";